import FeedbackSuccess from '../../../components/atoms/feedbacks/feedback-success'
import FeedbackError from '../../../components/atoms/feedbacks/feedback-error'
import PageHeadline from '../../../components/molecules/headlines/PageHeadline'

export default {
  components: {
    FeedbackSuccess,
    FeedbackError,
    PageHeadline
  },
  data() {
    return {
      newEmail: '',
      isFocusNewEmail: false,
      showableSuccessFeedback: false,
      successMessage: '',
      showableErrorFeedback: false,
      errorMessage: ''
    }
  },
  mounted() {
    const successMessage = document.querySelector('#flash_message').value
    if (successMessage) {
      this.showSuccessFeedback('認証メールを送信しました')
    }

    if (successMessage) {
      this.showSuccessFeedback(successMessage)
    }

    const errorMessage = document.querySelector('#flash_error_message').value
    if (errorMessage) {
      this.showErrorFeedback('メールアドレスを変更できませんでした')
    }

    const currentNewEmailHtml = document.querySelector(
      '#email_edit_form_new_email'
    ).outerHTML
    const currentNewEmail = currentNewEmailHtml.match(/value="(.*?)"/)
    if (currentNewEmail) {
      this.newEmail = currentNewEmail[1]
      this.isFocusNewEmail = true
    }
  },
  computed: {
    isNotEmptyNewEmail() {
      return this.newEmail.length !== 0
    },
    isNewEmailActive() {
      return this.isNotEmptyNewEmail || this.isFocusNewEmail
    },
    isSubmittable() {
      return this.isNotEmptyNewEmail
    }
  },
  methods: {
    onCurrentEmailFocus() {
      this.isFocusCurrentEmail = true
    },
    onCurrentEmailBlur() {
      this.isFocusCurrentEmail = false
    },
    onNewEmailFocus() {
      this.isFocusNewEmail = true
    },
    onNewEmailBlur() {
      this.isFocusNewEmail = false
    },
    enterSuccessFeedback() {
      setTimeout(() => {
        this.showableSuccessFeedback = false
      }, 3000)
    },
    showSuccessFeedback(message) {
      this.showableSuccessFeedback = true
      this.successMessage = message
    },
    enterErrorFeedback() {
      setTimeout(() => {
        this.showableErrorFeedback = false
      }, 3000)
    },
    showErrorFeedback(message) {
      this.showableErrorFeedback = true
      this.errorMessage = message
    }
  }
}
